import { isBrowser } from './isBrowser';

export const triggerReload = () => {
  if (isBrowser) window.location.reload();
};
